const MuiLink = {
  underline: 'always',
  variant: 'body1',
  color: 'textPrimary'
};
export default MuiLink;